import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useServiceProviderDBUtils = () => {
  const tempMenuGroup = [];

  /* menuItemUser */
  const menuItemProvider = {
    id: "serviceProviderDb",
    title: t("AppModuleNames.Provider.providerInfo"),
    url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER),
  };
  tempMenuGroup.push(menuItemProvider);

  return tempMenuGroup;
};
